<template>
  <div class="nav-vertical__item py-0 idontlooklikealink">
    <div class="backButtonContainer" tabindex="-1">
      <c-back-button
        v-if="showBackButton || selectedTag || selectedCategory"
        @click="onBackButtonClicked"
        @keyup.enter="onBackButtonClicked"
        @keyup.space="onBackButtonClicked"
        tabindex="0"
        :aria-label="ariaLabel"
      ></c-back-button>
    </div>
    <span class="nav-vertical__content px-2 ml-1"><h2>{{ name }}</h2></span>
    <button
      v-if="showChevron"
      :aria-label="`${name} Filter Options`"
      aria-haspopup="true"
      aria-expanded="false"
      class="btn btn--clean"
    >
      <i class="trigger fa fa-chevron-down"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    ariaLabel: String,
    name: { required: true, type: String },
    showBackButton: Boolean,
    showChevron: Boolean,
  },
  methods: {
    onBackButtonClicked(e) {
      this.$emit('back', e)
    },
  },
}
</script>
